import type { PreviewTextSample } from '../../../core/entities/ai-assist-config';
import { useLocale } from '../i18n/LocaleProvider';

export function PreviewTextPanel({
  preview,
  readonly,
  onInputChange,
  onRunPreview,
}: {
  preview: PreviewTextSample;
  readonly: boolean;
  onInputChange: (input: string) => void;
  onRunPreview: () => void;
}) {
  const { t } = useLocale();

  return (
    <section aria-label={t('settings.deidentification.preview')} className="panel-card">
      <h3>{t('settings.deidentification.preview')}</h3>
      <label className="field-stack">
        <span className="field-label">{t('settings.deidentification.previewInput')}</span>
        <textarea
          aria-label={t('settings.deidentification.previewInput')}
          className="workspace-textarea"
          onChange={(event) => onInputChange(event.currentTarget.value)}
          placeholder={t('settings.deidentification.previewPlaceholder')}
          rows={4}
          value={preview.inputText}
        />
      </label>
      <div className="hud-toolbar">
        <button className="hud-chip" disabled={readonly} onClick={onRunPreview} type="button">
          {t('settings.deidentification.runPreview')}
        </button>
      </div>
      <div className="preview-results">
        <label className="field-stack">
          <span className="field-label">{t('settings.deidentification.maskedResult')}</span>
          <textarea className="workspace-textarea" readOnly rows={3} value={preview.maskedText ?? ''} />
        </label>
        <label className="field-stack">
          <span className="field-label">{t('settings.deidentification.restoredResult')}</span>
          <textarea className="workspace-textarea" readOnly rows={3} value={preview.restoredText ?? ''} />
        </label>
      </div>
      {preview.issues.length > 0 && (
        <ul className="status-list alert-text" role="alert">
          {preview.issues.map((issue) => (
            <li key={issue}>{issue}</li>
          ))}
        </ul>
      )}
    </section>
  );
}
